// extracted by mini-css-extract-plugin
export default {"wrapperSizeButtons":"liR7V91w","button":"L4h8wBlo","down":"n4zVysPm","up":"xITQk5rV"};